import React from 'react';
import { Check } from 'lucide-react';

const PasswordRequirements = ({ checks, translations }) => {
  const requirements = [
    { key: 'length', text: translations("auth.password.length") },
    { key: 'uppercase', text: translations("auth.password.uppercase") },
    { key: 'lowercase', text: translations("auth.password.lowercase") },
    { key: 'number', text: translations("auth.password.number") },
    { key: 'special', text: translations("auth.password.special") }
  ];

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h4 className="text-sm font-medium text-gray-700 mb-2">{translations("auth.password.title")}</h4>
      <ul className="space-y-1">
        {requirements.map(({ key, text }) => (
          <li key={key} className={`flex items-center gap-2 text-sm ${checks[key] ? 'text-green-600' : 'text-gray-600'}`}>
            {checks[key] ? (
              <Check className="w-4 h-4" />
            ) : (
              <div className="w-4 h-4 rounded-full border border-gray-300" />
            )}
            {text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;